import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { SdkRuntimeConfigService } from './sdk-runtime-config.service';

/**
 * F-SDK REQ-F-SDK-074 — blocks the non-attendee surfaces that ship inside the
 * mobile bundle when the host application has asked for an attendee-only
 * experience.
 *
 * This exists because those surfaces cannot be excluded by packaging. The SDK
 * ships a single compiled Angular bundle, and booth-representative and
 * organiser tooling live in it; whether a user reaches them is decided at
 * runtime from the `role_ids` claim. So the code is present in the host
 * application whether or not the partner's users should ever see it, and a
 * runtime gate is the only available control.
 *
 * It is explicitly NOT an authorisation boundary. Server-side role and sudo
 * enforcement remains authoritative for every underlying API call; this guard
 * only stops the screens rendering.
 */
export const attendeeOnlyGuard: CanActivateFn = () => {
  const runtimeConfig = inject(SdkRuntimeConfigService);
  const router = inject(Router);

  if (!runtimeConfig.attendeeToolsOnly()) return true;

  return router.createUrlTree(['/tabs/home']);
};
